<footer class="footer ">
    <div class="container-fluid">
        <div class="copyright d-flex justify-content-between">
            <span>v {{ currentBuildNumber }}</span>
            <span>&copy; {{ test | date: 'yyyy' }}, Zainea_Nicoleta</span>
        </div>
    </div>
</footer>